import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../Interceptor";
import { getRoute } from "../api/routes";
import { setProjectList } from "../slices/app";
import { useSelector, useDispatch } from "react-redux";

const UserSiderProjectList = ({onMenuSelect}) => {
  const {projectList} = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchProjects = async () => {
    try {
      const response = await api.get(
        getRoute('users', 'user', 'projects', false, false, '')
      );
      dispatch(setProjectList(response.data));
    } catch (error) {
      if (error.response && error.response.data) {
        toast.error(`Failed to fetch projects: ${error.response.data.message}`);
      } else {
        toast.error('An error occurred while fetching projects.');
      }
      console.error('Fetch projects error:', error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    const handleAiRefresh = () => fetchProjects();
    window.addEventListener("ai:refreshProjects", handleAiRefresh);
    return () =>
      window.removeEventListener("ai:refreshProjects", handleAiRefresh);
  }, []);

  const handleOpenProjectDetail = (id, name) => {
    navigate('/user/project', { state: { projectId: id, projectName: name } });
    if (onMenuSelect) onMenuSelect();
  };

  return (
    <div className="ms-3 mt-4 font-customFont">
      <div className="flex justify-between ">
        <h6 className="font-semibold text-gray-800 text-sm">PROJECTS</h6>
      </div>
      <div>
        {Array.isArray(projectList) && projectList.length > 0 && (
          <ul className="space-y-0 mt-1 max-h-72 overflow-y-auto scrollbar-hidden">
            {projectList.map((projectItem) => (
              <div
                className="group flex items-center px-2 py-2 rounded-lg cursor-pointer transition-all duration-300 hover:bg-gray-100"
                onClick={() =>
                  handleOpenProjectDetail(projectItem?._id, projectItem?.name)
                }
              >
                <div className="w-6 h-6 rounded-md bg-gradient-to-br from-purple-100 to-purple-200 flex items-center justify-center mr-3 group-hover:from-purple-200 group-hover:to-purple-300 transition-all duration-300">
                  <i className="fas fa-folder text-purple-600 text-xs"></i>
                </div>
                <span className="text-gray-700 text-sm font-medium truncate group-hover:text-purple-600 transition-colors duration-300">
                  {projectItem?.name}
                </span>
              </div>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default UserSiderProjectList;
